// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__wOnwd","title":"ClientCherryInfo_title__3lN8X","itemText":"ClientCherryInfo_itemText__3ykdk"};